/*
 * @Author: xxx
 * @Date: 2023-03-16 09:30:16
 * @LastEditors: xxx
 * @LastEditTime: 2023-03-16 09:30:39
 * @Description:
 */
export default [
  {
    path: "/question",
    name: "question",
    component: () => import("@/views/question/index.vue"),
    meta: {
      title: "常见问题"
    }
  }
];
